import React, { useState } from 'react';

import UbiquitiHostsCards from '@totem/components/ubiquiti/hosts/List/UbiquitiHostsCards';
import UbiquitiHostsContainer from '@totem/components/ubiquiti/hosts/List/UbiquitiHostsContainer';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

const UbiquitiHostsPage = () => {
  const [totalRecords, setTotalRecords] = useState<number>(0);

  return (
    <ContentLayout>
      <InputContainer
        componentKey={'dashboard.ubiquitiHosts'}
        componentLabel={'Portfolio: Ubiquiti Hosts'}
        filterConfig={[]}
        useUrlParams
        defaultSort={{
          field: 'device.displayName',
          direction: 'ascend',
        }}
      >
        <UbiquitiHostsContainer onRecordTotalChanged={setTotalRecords}>
          <IBCard
            isCovered
            title={'Ubiquiti Hosts'}
            extra={<RecordCountBadge count={totalRecords} />}
          >
            <UbiquitiHostsCards />
          </IBCard>
        </UbiquitiHostsContainer>
      </InputContainer>
    </ContentLayout>
  );
};

export default UbiquitiHostsPage;
